var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._g(_vm._b({attrs:{"items":_vm.items,"value":_vm.value,"rules":_vm.rules,"item-text":"name","item-value":_vm.selectName ? 'name' : 'id',"solo":"","loading":_vm.loading}},'v-select',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }